import * as types from '../constants/agendaitemdetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  agendaitemdetails: null,
  agendaitemdetailsList: null,
  agendaitemuserList: null
}

export function agendaitemDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_AGENDAITEM_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_AGENDAITEM_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        agendaitemdetails: action.data
      };
    case types.FETCH_AGENDAITEM_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // agendaitemdetailsList:action.error
      };
    case types.FETCH_AGENDAITEM_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        agendaitemdetailsList: null,
        agendaitemdetails: null,
      };
    case types.FETCH_AGENDAITEM_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_AGENDAITEM_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        agendaitemdetailsList: action.data
      };
    case types.FETCH_AGENDAITEM_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false
      };
      case types.FETCH_AGENDAITEM_USER_LIST_REQUEST:
        return {
          ...state,
          Status: true
        };
      case types.FETCH_AGENDAITEM_USER_LIST_REQUEST_COMPLETED:
        return {
          ...state,
          Status: false,
          apiGetResult: true,
          agendaitemuserList: action.data
        };
      case types.FETCH_AGENDAITEM_USER_LIST_REQUEST_ERROR:
        return {
          ...state,
          Status: false,
          apiGetResult: false,
          // agendaitemdetailsList:action.error
        };
    case types.ADD_AGENDAITEM_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_AGENDAITEM_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.ADD_AGENDAITEM_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_AGENDAITEM_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
      case types.UPDATE_FILE_REQUEST:
        return {
          ...initialState,
          Status: true
        };
      case types.UPDATE_FILE_REQUEST_COMPLETED:
        return {
          ...state,
          Status: false,
          apiPostResult: true
        };
      case types.UPDATE_FILE_REQUEST_ERROR:
        return {
          ...state,
          Status: false,
          apiPostResult: false
        };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/agendaitemdetails.js